import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import UnitOpLinkingStudyFlowchart from 'studies/typed/shared/unit-op-linking-flowchart/UnitOpLinkingStudyFlowchart';

import VisualizationState from './VisualizationState';

export default class VisualizationView extends Backbone.View<VisualizationState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  initialize(): void {
    this.listenTo(this.model, 'change', () => this.render());
  }

  render(): this {
    const id = this.model.get('studyId');
    renderToDOM(<UnitOpLinkingStudyFlowchart studyId={id} />, this.el);
    return this;
  }

  remove(): Backbone.View<VisualizationState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

VisualizationView.initClass();
